import React from 'react';
import {connect} from 'react-redux';
import {login} from '../actions/UsuarioActions';
import {Redirect} from 'react-router-dom';

const styles = {
  formSignin: {
    maxWidth: "380px",
    padding: "40px",
    backgroundColor: "#fff",
    borderRadius: "25px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  formSigninControl: {
    border: "0 none",
    borderRadius: "15px",
    backgroundColor: "#E8F0FE",
    marginBottom: "20px"
  }
};

class Login extends React.Component {
  constructor(props){
    super(props);
    document.title = "Login :: Alpha Ultrapress";
    this.state = {
      credentials: {
        login: "",
        senha: ""
      }
    };
  }

  onChange(event){
    const field = event.target.name;
    const credentials = this.state.credentials;
    credentials[field] = event.target.value.trim();
    return this.setState({credentials});
  }

  handleFormSubmit(event){
    event.preventDefault();
    this.props.login(this.state.credentials);
  }

  render(){
    if(this.props.usuario){
      return (
        <Redirect to="/" />
      )
    }

    return (
      <div style={{display: "flex", height: "100vh", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
        <form onChange={this.onChange.bind(this)} onSubmit={this.handleFormSubmit.bind(this)}>
          <div style={styles.formSignin}>
            <img src="images/logo-alpha-convite.png" width="150"/>
            <h2 style={{marginBottom: 10, marginTop: 20}}>Login Administrativo<i className="fa fa-spin fa-fw fa-spinner pull-right" style={this.props.carregando ? {display: ""} : {display: "none"}}></i></h2>
            <br/><br/>
            <label htmlFor="login" style={{textAlign: "left", width: "100%"}}>Usuário</label>
            <input type="text" name="login" id="login" value={this.state.credentials.login} className="form-control" style={styles.formSigninControl} placeholder="johndoe" required />
            <label htmlFor="senha" style={{textAlign: "left", width: "100%"}}>Senha</label>
            <input type="password" name="senha" id="senha" style={{marginTop: 15}} value={this.state.credentials.senha} className="form-control" style={styles.formSigninControl} placeholder="••••••" required/>
            <input type="submit" className="btn btn-lg bg-black btn-block" style={{borderRadius: "25px", marginTop: 30}} value="Entrar"/>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    carregando: state.usuario.carregando,
    erro: state.usuario.erro
  };
};

export default connect(mapStateToProps, {login})(Login);



// WEBPACK FOOTER //
// ./src/views/Login.js